<template>
  <div class="detail-page">
    <!-- 头部面包屑以及文字，和编辑功能 -->

    <BreadCrumb :data="breadcrumb" :title="'基地详情管理'" />
    <El-button v-if="!isEditting" @click="edit()" class="edit-btn"
      >编辑</El-button
    >
    <div v-show="!isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgBox">
          <img
            v-if="baseDetail.cover_image"
            :src="baseDetail.cover_image"
            alt=""
            class="form-content-img"
          />
          <img
            v-else
            src="../../../../static/image/no-img.png"
            alt=""
            class="form-content-img no-img"
          />
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="one-third">
            <h4>中文名</h4>
            <span>{{ baseDetail.chinese_name }}</span>
          </li>
          <li class="one-third">
            <h4>英文名</h4>
            <span>{{ baseDetail.english_name }}</span>
          </li>
          <li class="exclusive">
            <h4>组织</h4>
            <span>{{ baseDetail.organization ? baseDetail.organization.chinese_name : ""}}</span>
          </li>
          <li class="exclusive">
            <h4>经纬度</h4>
            <span>lng{{baseDetail.lng}} lat{{baseDetail.lat}}</span>
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="baseDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              disabled
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <div v-show="isEditting" class="detail-form-information">
      <h2>基本信息</h2>
      <div class="form-content">
        <!-- 左边边图片 -->
        <div class="imgbox">
          <UploadImage
            :img="baseDetail.cover_image"
            :width="230"
            :height="160"
            @getUploadImage="getUploadCoverImage"
          ></UploadImage>
        </div>
        <!-- 右边文字内容 -->
        <ul class="form-content-description">
          <li class="exclusive">
            <h4>中文名<span>*</span></h4>
            <el-input
              v-model="baseDetail.chinese_name"
              placeholder="请输入中文标题"
            ></el-input>
          </li>
          <li class="exclusive">
            <h4>英文名<span>*</span></h4>
            <el-input
              v-model="baseDetail.english_name"
              placeholder="请输入英文标题"
            ></el-input>
          </li>
          <!-- <li class="exclusive">
            <h4>组织</h4>
            <el-autocomplete
              
              v-model="baseDetail.organization"
              :fetch-suggestions="searchOrganizations"
              @select="handleSelect"
              placeholder="选择组织"
            >
            </el-autocomplete>
          </li> -->

          <li class="half">
            <h4>经度</h4>
                    <el-input-number
          v-model.number="baseDetail.lng"
          @input.native="onInput"
        ></el-input-number>
          </li>
          <li class="half">
            <h4>纬度</h4>
                    <el-input-number
          v-model.number="baseDetail.lng"
          @input.native="onInput"
        ></el-input-number>
          </li>
                              <li class="half">
            <h4>组织</h4>
            <el-select
              v-model="baseDetail.organization"
              clearable
              filterable
              placeholder="请选择"
              value-key="chinese_name"
            >
              <el-option
                v-for="item in organizationList"
                :key="item.label"
                :label="item.chinese_name"
                :value="item"
              ></el-option>
            </el-select>
          </li>
          <li class="one-third">
            <h4>状态</h4>
            <el-switch
              v-model="baseDetail.status"
              active-color="#91CC75"
              inactive-color="#C7C7C7"
              :active-value="1"
              :inactive-value="0"
              style="align-self: center"
            >
            </el-switch>
          </li>
        </ul>
      </div>
    </div>
    <div class="base-images">
      <h2>基地图片</h2>

      <div class="images-box">
        <UploadImage
          v-if="isEditting"
          :width="230"
          :height="120"
          @getUploadImage="getUploadBaseImage"
          class="form-content-img upload-image"
        ></UploadImage>

        <div class="image-list">
          <div
            class="image-item"
            v-for="(item, index) in baseDetail.images"
            :key="index"
          >
            <img :src="item" />
            <i
              v-show="isEditting"
              @click="removeImgae(index)"
              class="el-icon-error iconPosi"
            ></i>
          </div>
        </div>
      </div>
    </div>
        <div class="pc-works-books" v-show="isEditting">
      <!-- 作品文件 -->
      <div class="pc-works-textbook">
        <h2>基地文件</h2>
        <UploadFile
          :file="baseDetail.docs"
          @getUploadFile="getUploadDocs"
          :title="'基地文件'"
        ></UploadFile>
      </div>
    </div>
    <div class="pc-dataDetail-intro">
      <h2>基地介绍</h2>

      <div class="content">
        <h4>中文简介</h4>
        <el-input
          type="textarea"
          v-if="isEditting"
          :rows="15"
          placeholder="请输入内容"
          v-model="baseDetail.chinese_introduce"
        >
        </el-input>
        <p v-else class="worksDetailIntro">
          {{ baseDetail.chinese_introduce }}
        </p>
      </div>
                  <TranslateText
          class="translate-btn"
          v-if="isEditting"
          :chinese="baseDetail.chinese_introduce"
          :english="baseDetail.english_introduce"
          @returnTranslate="returnTranslate"
        />
      <div class="content">
        <h4>英文简介</h4>
        <el-input
          v-if="isEditting"
          type="textarea"
          :rows="15"
          placeholder="请输入内容"
          v-model="baseDetail.english_introduce"
        >
        </el-input>
        <p v-else class="worksDetailIntro">
          {{ baseDetail.english_introduce }}
        </p>
      </div>
    </div>
              <EditContent
      ref="baseContent"
      :header="'展览'"
      :content="baseDetail.detail"
      :isEditting="isEditting"
    ></EditContent>
    <SaveGroup
      :isEditting="isEditting"
      @cancelUpdate="cancelUpdate"
      @save="save"
      @recover="recover"
      @view="view"
      @cancelAdd="cancelAdd"
      @add="add"
    />
  </div>
</template>
<script>
import BreadCrumb from "@/components/componentSet/BreadCrumb";
import UploadImage from "../../componentSet/uploadImage.vue";
import SaveGroup from "../../componentSet/SaveGroup.vue";
import EditContent from "../../componentSet/EditContent.vue";
import TranslateText from "../../componentSet/TranslateText.vue";
import {
  getBaseDetail_Api,
  setBaseDetail_Api,
  updateBaseDetail_Api,
  getOrganizationSearch_Api,
  organizationDropDown_Api
} from "@/apis/exhibition.api";
import TagDetail from "@/components/template/TagDetail";
import UploadFile from "../../componentSet/uploadFile.vue";
export default {
  components: {
    UploadImage,
    BreadCrumb,
    SaveGroup,
    TagDetail,
    UploadFile,
    EditContent,
    TranslateText
  },
  computed: {
    breadcrumb: function () {
      return [
        {
          name: "首页",
          link: "/admin/main",
        },
        { name: "基地列表", link: "/admin/otherList" },
        {
          name: `${
            (
              this.baseDetail.chinese_name
                ? this.baseDetail.chinese_name
                : this.baseDetail.english_name
            )
              ? this.baseDetail.chinese_name
                ? this.baseDetail.chinese_name
                : this.baseDetail.english_name
              : ""
          }`,
          link: "/admin/baseDetail",
        },
      ];
    },
  },
  data() {
    return {
      isEditting: true,
      baseDetail: {
        id: null,
        chinese_introduce: "",
        english_introduce: "",
        images_list: [],
        cover_image: "",
        lng: null,
        lat: null,
        organization_id: null,
        organization:{}
      },
      searchOrganization: {},
      organizationList:[]
    };
  },
  mounted() {
    if (this.$route.query.method == "update") {
      this.baseDetail.id = this.$route.query.id;
      this.getBaseDetail();
    }
        organizationDropDown_Api().then((res) => {
      this.organizationList = res.data;
      console.log(res.data);
    });
  },

  methods: {
       onInput(e) {
       e.target.value=e.target.value.replace(/[^\d.]/g,'');
    },
            returnTranslate(data, flag) {
      flag == 1
        ? ( this.baseDetail.english_introduce= data)
        : (this.baseDetail.chinese_introduce = data);
      console.log(data);
      console.log(flag);
    },
    getUploadCoverImage(img_url) {
      this.baseDetail.cover_image = img_url;
    },
        getUploadDocs(file_url) {
      this.baseDetail.docs = file_url;
    },
    getBaseDetail(hint) {
      getBaseDetail_Api(this.baseDetail.id).then((res) => {
        hint ? this.$global.success(this, hint) : "";
        this.baseDetail = res.data;
                if(this.baseDetail.lng == ""){
          this.baseDetail.lng = undefined
        }
                if(this.baseDetail.lat == ""){
          this.baseDetail.lat = undefined
        }
        // this.baseDetail.lng = parseFloat(res.data.lng);
        // this.baseDetail.lat = parseFloat(res.data.lat);
        console.log(this.baseDetail);
      });
    },
    // save group 回调函数
    cancelUpdate() {
      this.getBaseDetail("取消成功");
      this.isEditting = false;
    },
    recover() {
      this.getBaseDetail("恢复成功");
    },
    view() {
      window.open("http://wupen.org/exhibition/basement/" + this.$route.query.id, "_blank");
    },
    cancelAdd() {
      window.close();
    },
    add() {
      let formattedData = this.validateForm(this.baseDetail);
      if (!formattedData) {
        return;
      } else {
        setBaseDetail_Api(formattedData)
          .then((res) => {
            this.isEditting = false;
            this.baseDetail.id = res.data.id;
            this.getBaseDetail();
            this.$router.push({
              path: "/admin/baseDetail",
              query: { id: res.data.id, method: "update" },
            });
            this.$global.success(this, "创建成功！", null);
          })
          .catch((err) => {
            this.$global.error(this, "创建失败！", null);
          });
      }
    },
    save() {
      let formattedData = this.validateForm(this.baseDetail);
      if (!formattedData) {
        return;
      } else {
        updateBaseDetail_Api(formattedData)
          .then((res) => {
            if (res.code === 205) {
              this.$global.success(this, "更新成功");
              this.getBaseDetail();
              this.isEditting = false;
            } else {
              this.$global.error(this, "更新失败！", null);
            }
          })
          .catch(() => {
            this.$global.error(this, "更新失败！", null);
          });
      }
    },
    // 点击编辑
    edit() {
      this.isEditting = true;
    },
    getUploadBaseImage(img_url) {
      this.baseDetail.images_list.unshift(img_url);
      console.log(this.baseDetail.images_list);
    },
    removeImgae(index) {
      this.baseDetail.images_list.splice(index, 1);
    },
    validateForm(formData) {
      //表单校验
      if (!formData.chinese_name || !formData.english_name) {
        this.$global.error(this, "请输入中英文标题");
        return false;
      }
            if (formData.organization) {
        formData.organization_id = formData.organization.id;
      }else{
        formData.organization_id =0
      }
      formData.detail = this.$refs.baseContent.getContent();
      formData.images = formData.images_list;
      formData.base_id = formData.id;
      console.log(formData);
      return formData;
    },
  },
};
</script>
<style lang="scss" scoped>
.imgBox {
  width: 200px;
  height: 200px;
}

/deep/ .el-select {
  width: 100%;
}
.imgBox .form-content-img {
  width: 100%;
  height: 100%;
}
  .worksDetailIntro{
    word-break:break-all;
    text-indent:2em
  }
.no-img {
  width: 200px !important;
  height: 150px !important;
}
.base-images {
  @include box-model;
  .images-box {
    overflow-y: hidden;
    overflow-x: auto;
    display: flex;
    height: 170px;
    .upload-image {
      margin-right: 20px;
    }
    .image-list {
      display: flex;
      .image-item {
        position: relative;
        display: inline-block;
        margin-right: 20px;
        img {
          height: 140px;
        }
        .el-icon-error {
          color: $base-color;
          cursor: pointer;
          position: absolute;
          top: 10px;
          right: 10px;
        }
      }
      .image-item:last-child {
        margin-right: 0px;
      }
    }
  }
}
  .pc-works-books {
    display: flex;
    width: 100%;
    justify-content: space-between;
    /deep/ button.el-button.el-button--primary.el-button--small {
      padding: 0;
      background: #fff;
      color: #000;
      border: none;
    }
    /deep/ .el-icon-document:before {
      margin-right: 10px;
    }
    .pc-works-textbook {
      @include box-model;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/exhibition/BaseDetail.vue